import { ExperienceChildConfigKind } from '@/types/gql.generated';
import { Badge, Box, Flex, Icon, Text } from '@/ui';
import type { ThumbnailKind } from './LayoutThumbnail';
import { LayoutThumbnail } from './LayoutThumbnail';

export type DisplayConfig = {
  description: string;
  kind: ExperienceChildConfigKind;
  label: string;
  thumbnailKind: ThumbnailKind;
};

type Props = {
  config: DisplayConfig;
  isSelected: boolean;
  onSelect: () => void;
};

export const LayoutOptionCard = ({ config, isSelected, onSelect }: Props) => (
  <Flex
    align="center"
    as="button"
    bg="white"
    border="1.5px solid"
    borderColor={isSelected ? 'magicPurple.500' : 'line.DEFAULT'}
    borderRadius="ah-xl"
    boxShadow={isSelected ? 'ah-ring-selected' : undefined}
    cursor="pointer"
    gap={3}
    mb={2}
    p={3}
    textAlign="left"
    transition="border-color 0.14s, transform 0.14s, box-shadow 0.14s"
    type="button"
    w="full"
    _hover={
      isSelected
        ? undefined
        : { borderColor: 'rgba(93,63,246,0.4)', transform: 'translateY(-1px)' }
    }
    onClick={onSelect}
  >
    <LayoutThumbnail kind={config.thumbnailKind} />

    <Box flex={1} minW={0}>
      {config.kind === ExperienceChildConfigKind.Printable && (
        <Badge mb={1} variant="printable">
          Printable
        </Badge>
      )}

      <Flex align="center" gap={1.5}>
        <Text
          color={isSelected ? 'magicPurple.700' : 'ink.strong'}
          fontSize="ah-row"
          fontWeight={700}
        >
          {config.label}
        </Text>
        {isSelected && (
          <Icon color="magicPurple.500" icon="Checkmark" size={4} />
        )}
      </Flex>

      <Text color="ink.muted" fontSize="ah-label" lineHeight={1.4} mt={0.5}>
        {config.description}
      </Text>
    </Box>
  </Flex>
);
